import { h } from 'preact'
import { i18n } from 'i18n/i18n'

import { ChosenItemTransfer, TransferFeesObj } from 'models/exchange-transfer-calculate'

import { formatAmountWithCurrency } from 'utils/format-number'
import { SelectSingleOption } from 'common-modules/selects/calculator-select-option'
import { useSelectVisibility } from 'hooks/useSelectVisibility'

interface CalculatorTransferTypeSelectProps {
  transferFees: TransferFeesObj[]
  chosenItemTransfer: ChosenItemTransfer
  handleSetTransferType: (transferType: string, transferFee: string) => void
}

const getTransferTypeLabel = (transferType?: string, transferFee?: string): string => {
  if (!transferType) {
    return ''
  }
  const transferTypeHeader = i18n(`transferTypes.${transferType.toLowerCase()}.header`)
  return `${transferTypeHeader} (${formatAmountWithCurrency(transferFee)})`
}

const getTransferTypeSubtext = (transferType: string): string =>
  i18n(`transferTypes.${transferType.toLowerCase()}.subtext`)?.toString() || ''

export const CalculatorTransferTypeSelect = ({
  transferFees,
  chosenItemTransfer,
  handleSetTransferType,
}: CalculatorTransferTypeSelectProps) => {
  const {
    isSelectVisible,
    toggleSelectVisibility,
    triggerRef,
    containerRef,
    listRef,
    handleTriggerKeyDown,
    handleListKeyDown,
  } = useSelectVisibility()

  return (
    <div
      ref={containerRef}
      className="preact-select preact-select--transfer-type"
    >
      <div
        ref={triggerRef}
        className="preact-select__trigger"
        aria-expanded={isSelectVisible}
        role="button"
        tabIndex={0}
        onClick={toggleSelectVisibility}
        onKeyDown={handleTriggerKeyDown}
        data-value={chosenItemTransfer.chosenItemTransferType}
      >
        <span className="preact-select__option-name">
          {getTransferTypeLabel(chosenItemTransfer.chosenItemTransferType, chosenItemTransfer.chosenItemTransferFee)}
        </span>
        <span className="preact-select__chevron" />
      </div>

      {isSelectVisible && (
        <div
          ref={listRef}
          className="preact-select__options-list"
          role="listbox"
          onKeyDown={handleListKeyDown}
          onClick={toggleSelectVisibility}
        >
          {transferFees.map((transferFee) => (
            <SelectSingleOption
              key={`${transferFee.transfer_type}-${transferFee.fee}`}
              option={transferFee.transfer_type}
              optionName={getTransferTypeLabel(transferFee.transfer_type, transferFee.fee)}
              handleSetClickedOption={() => handleSetTransferType(transferFee.transfer_type, transferFee.fee)}
              description={getTransferTypeSubtext(transferFee.transfer_type)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
